import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';
import Section from '../ui/Section';
import Card from '../ui/Card';
import { Ruler, HardHat, Building2, FileText, PenTool, ShieldCheck } from 'lucide-react';

const Services = () => {
    const { t } = useLanguage();

    const icons = [
        <Building2 className="w-10 h-10 text-gold-500" />,
        <Ruler className="w-10 h-10 text-gold-500" />,
        <PenTool className="w-10 h-10 text-gold-500" />,
        <HardHat className="w-10 h-10 text-gold-500" />,
        <FileText className="w-10 h-10 text-gold-500" />,
        <ShieldCheck className="w-10 h-10 text-gold-500" />,
        <FileText className="w-10 h-10 text-gold-500" />
    ];

    return (
        <Section id="services" background="slate">
            <div className="text-center max-w-3xl mx-auto mb-16">
                <h2 className="text-3xl md:text-4xl font-bold mb-4 text-slate-900">{t.services.title}</h2>
                <p className="text-slate-600 text-lg">
                    {t.services.description}
                </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {t.services.items.map((service, index) => (
                    <Card key={index} className="p-8 hover:border-gold-500/50 transition-colors">
                        <div className="mb-6 bg-slate-50 w-16 h-16 rounded-full flex items-center justify-center">
                            {icons[index % icons.length]}
                        </div>
                        <h3 className="text-xl font-bold mb-3 text-slate-900">{service.title}</h3>
                        <p className="text-slate-600 leading-relaxed whitespace-pre-line">
                            {service.details}
                        </p>
                    </Card>
                ))}
            </div>
        </Section>
    );
};

export default Services;
